import React from 'react';
import { TableWrapper } from './TableWrapper';
interface SystemsTabProps {
  searchTerm: string;
}
export function SystemsTab({
  searchTerm
}: SystemsTabProps) {
  const systems = [{
    channel: 'LU (Lung)',
    location: 'Hand Tai Yin',
    sys1: 'SP (Spleen)',
    sys2: 'BL (Bladder)',
    sys3: 'LI (Large Int.)',
    sys4: 'BL (Bladder)',
    sys5: 'LR (Liver)',
    sys6: 'LU (Lung)'
  }, {
    channel: 'LI (Large Intestine)',
    location: 'Hand Yang Ming',
    sys1: 'ST (Stomach)',
    sys2: 'LR (Liver)',
    sys3: 'LU (Lung)',
    sys4: 'KI (Kidney)',
    sys5: 'ST (Stomach)',
    sys6: 'LI (Large Int.)'
  }, {
    channel: 'ST (Stomach)',
    location: 'Foot Yang Ming',
    sys1: 'LI (Large Int.)',
    sys2: 'PC (Pericardium)',
    sys3: 'SP (Spleen)',
    sys4: 'PC (Pericardium)',
    sys5: 'LI (Large Int.)',
    sys6: 'ST (Stomach)'
  }, {
    channel: 'SP (Spleen)',
    location: 'Foot Tai Yin',
    sys1: 'LU (Lung)',
    sys2: 'SI (Small Int.)',
    sys3: 'ST (Stomach)',
    sys4: 'TH (Triple Heater)',
    sys5: 'HT (Heart)',
    sys6: 'SP (Spleen)'
  }, {
    channel: 'HT (Heart)',
    location: 'Hand Shao Yin',
    sys1: 'KI (Kidney)',
    sys2: 'GB (Gallbladder)',
    sys3: 'SI (Small Int.)',
    sys4: 'GB (Gallbladder)',
    sys5: 'SP (Spleen)',
    sys6: 'HT (Heart)'
  }, {
    channel: 'SI (Small Intestine)',
    location: 'Hand Tai Yang',
    sys1: 'BL (Bladder)',
    sys2: 'SP (Spleen)',
    sys3: 'HT (Heart)',
    sys4: 'LR (Liver)',
    sys5: 'BL (Bladder)',
    sys6: 'SI (Small Int.)'
  }, {
    channel: 'BL (Bladder)',
    location: 'Foot Tai Yang',
    sys1: 'SI (Small Int.)',
    sys2: 'LU (Lung)',
    sys3: 'KI (Kidney)',
    sys4: 'LU (Lung)',
    sys5: 'SI (Small Int.)',
    sys6: 'BL (Bladder)'
  }, {
    channel: 'KI (Kidney)',
    location: 'Foot Shao Yin',
    sys1: 'HT (Heart)',
    sys2: 'TH (Triple Heater)',
    sys3: 'BL (Bladder)',
    sys4: 'LI (Large Int.)',
    sys5: 'PC (Pericardium)',
    sys6: 'KI (Kidney)'
  }, {
    channel: 'PC (Pericardium)',
    location: 'Hand Jue Yin',
    sys1: 'LR (Liver)',
    sys2: 'ST (Stomach)',
    sys3: 'TH (Triple Heater)',
    sys4: 'ST (Stomach)',
    sys5: 'KI (Kidney)',
    sys6: 'PC (Pericardium)'
  }, {
    channel: 'TH (Triple Heater)',
    location: 'Hand Shao Yang',
    sys1: 'GB (Gallbladder)',
    sys2: 'KI (Kidney)',
    sys3: 'PC (Pericardium)',
    sys4: 'SP (Spleen)',
    sys5: 'GB (Gallbladder)',
    sys6: 'TH (Triple Heater)'
  }, {
    channel: 'GB (Gallbladder)',
    location: 'Foot Shao Yang',
    sys1: 'TH (Triple Heater)',
    sys2: 'HT (Heart)',
    sys3: 'LR (Liver)',
    sys4: 'HT (Heart)',
    sys5: 'TH (Triple Heater)',
    sys6: 'GB (Gallbladder)'
  }, {
    channel: 'LR (Liver)',
    location: 'Foot Jue Yin',
    sys1: 'PC (Pericardium)',
    sys2: 'LI (Large Int.)',
    sys3: 'GB (Gallbladder)',
    sys4: 'SI (Small Int.)',
    sys5: 'LU (Lung)',
    sys6: 'LR (Liver)'
  }];
  const sideRules = ['OPPOSITE', 'EITHER', 'OPPOSITE', 'EITHER', 'OPPOSITE', 'SAME'];
  return <div className="bg-gray-50 p-6 rounded-xl shadow-md" data-id="element-815">
      <h2 className="text-3xl font-bold text-gray-800 mb-4 pb-3 border-b-4 border-purple-600" data-id="element-816">
        Six Systems - Meridian Balance Relationships
      </h2>
      <p className="mb-6 text-gray-700" data-id="element-817">
        <strong data-id="element-818">How to use:</strong> When a channel is affected/painful, choose
        from the corresponding systems to find balancing channels for treatment.
      </p>
      <TableWrapper searchTerm={searchTerm} data-id="element-819">
        <div className="overflow-x-auto" data-id="element-820">
          <table className="w-full border-collapse bg-white rounded-lg overflow-hidden shadow-lg" data-id="element-821">
            <thead data-id="element-822">
              <tr className="bg-gradient-to-r from-purple-600 to-purple-800 text-white" data-id="element-823">
                <th className="p-4 text-left text-sm font-semibold" data-id="element-824">
                  Affected Channel
                </th>
                <th className="p-4 text-left text-sm font-semibold" data-id="element-825">
                  System 1<br data-id="element-826" />
                  <span className="text-xs font-normal" data-id="element-827">(Name-Sharing)</span>
                </th>
                <th className="p-4 text-left text-sm font-semibold" data-id="element-828">
                  System 2<br data-id="element-829" />
                  <span className="text-xs font-normal" data-id="element-830">(Bie-Jing)</span>
                </th>
                <th className="p-4 text-left text-sm font-semibold" data-id="element-831">
                  System 3<br data-id="element-832" />
                  <span className="text-xs font-normal" data-id="element-833">(Biao-Li)</span>
                </th>
                <th className="p-4 text-left text-sm font-semibold" data-id="element-834">
                  System 4<br data-id="element-835" />
                  <span className="text-xs font-normal" data-id="element-836">(Clock Opposite)</span>
                </th>
                <th className="p-4 text-left text-sm font-semibold" data-id="element-837">
                  System 5<br data-id="element-838" />
                  <span className="text-xs font-normal" data-id="element-839">(Clock Neighbor)</span>
                </th>
                <th className="p-4 text-left text-sm font-semibold" data-id="element-840">
                  System 6<br data-id="element-841" />
                  <span className="text-xs font-normal" data-id="element-842">(Self-Balance)</span>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-843">
              {systems.map((system, index) => <tr key={index} className="border-b border-gray-200 hover:bg-blue-50 transition-colors even:bg-gray-50" data-id="element-844">
                  <td className="p-3" data-id="element-845">
                    <div className="font-semibold text-gray-800" data-id="element-846">
                      {system.channel}
                    </div>
                    <div className="text-sm text-gray-600" data-id="element-847">
                      {system.location}
                    </div>
                  </td>
                  <td className="p-3 font-mono text-blue-600 font-medium" data-id="element-848">
                    {system.sys1}
                  </td>
                  <td className="p-3 font-mono text-orange-600 font-medium" data-id="element-849">
                    {system.sys2}
                  </td>
                  <td className="p-3 font-mono text-orange-600 font-medium" data-id="element-850">
                    {system.sys3}
                  </td>
                  <td className="p-3 font-mono text-blue-600 font-medium" data-id="element-851">
                    {system.sys4}
                  </td>
                  <td className="p-3 font-mono text-orange-600 font-medium" data-id="element-852">
                    {system.sys5}
                  </td>
                  <td className="p-3 font-mono text-green-600 font-medium" data-id="element-853">
                    {system.sys6}
                  </td>
                </tr>)}
              <tr className="bg-gradient-to-r from-purple-100 to-purple-200" data-id="element-854">
                <td className="p-3 font-bold text-gray-800" data-id="element-855">Side to Needle:</td>
                {sideRules.map((rule, index) => <td key={index} className={`p-3 text-center font-bold ${rule === 'OPPOSITE' ? 'bg-yellow-100 text-yellow-800' : rule === 'EITHER' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'}`} data-id="element-856">
                    {rule}
                  </td>)}
              </tr>
            </tbody>
          </table>
        </div>
      </TableWrapper>
    </div>;
}